import styled, { css } from 'styled-components';

export const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  bottom: 60px;

  @media(min-width: 768px) and (max-width: 1440px) {
    bottom: -30px;
    z-index: 20;
  }

  @media(min-width: 1440px) {
    bottom: 0;
  }
`;

export const ToggleContainer = styled.div.attrs({
  className: 'toggle-container',
})`
  ${({ theme }) => {
    const { colors } = theme;
    return css`
      display: flex;
      justify-content: center;
      border: 2px solid ${colors.secondary.pumice};
      border-radius: 32px;
      padding: 10px;
      position: relative;
      min-width: 274px;
      background-color: ${colors.primary.white};
    `;
  }}
`;

export const ToggleButton = styled.button.attrs({
  className: 'toggle-button',
})`
  ${({ theme, netflixToggleActive }) => {
    const { colors } = theme;
    return css`
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;
      border: none;
      background-color: transparent;
      cursor: pointer;
      flex: 1;
      z-index: 1;
      transition: color 0.3s;
      color: ${netflixToggleActive ? colors.primary.gravity : colors.primary.white};
      padding: 0 0 0 12px;

      &.netflix-logo-wrapper {
        display: flex;
        align-items: center;

        img {
          width: 53px;
          height: 14px;
          margin-right: 5px;
        }
      }

      &:first-child {
        padding: 0 0 0 3px;
      }

      &:focus {
        outline: none;
      }
    `;
  }}
`;

export const Slider = styled.div.attrs({
  className: 'slider',
})`
  ${({ theme, netflixToggleActive }) => {
    const { colors } = theme;
    return css`
      position: absolute;
      top: 4px;
      bottom: 4px;
      left: ${netflixToggleActive ? '4px' : '50%'};
      right: ${netflixToggleActive ? '50%' : '4px'};
      background-color: ${colors.primary.gravity};
      border-radius: 32px;
      transition: all 0.3s ease;
      z-index: 0;
    `;
  }}
`;
